export const textProps = { color: "text.primary", variant: "body1" };
